import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import { StyledClaimOnBoardCard } from './UserClaimsOnboardDentolo.styled';

const OnboardCard = ({ titleHtml, bodyText, children }) => {
  return (
    <StyledClaimOnBoardCard>
      <Typography variant="h1" dangerouslySetInnerHTML={{ __html: titleHtml || '' }} />
      {children}
      <Typography variant="p">{bodyText || ``}</Typography>
    </StyledClaimOnBoardCard>
  );
};

OnboardCard.propTypes = {
  titleHtml: PropTypes.string,
  bodyText: PropTypes.string,
  children: PropTypes.node,
};

export default OnboardCard;
